var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 19.8103C40.0067 24.8311 38.0783 29.6653 34.6082 33.3268C34.5535 33.3841 34.4842 33.4258 34.4076 33.4473C34.331 33.4689 34.25 33.4696 34.173 33.4494H34.1376L33.0585 32.4651L33.0302 32.4406C32.9666 32.3741 32.8923 32.311 32.8215 32.2375L32.3616 31.7997L31.4877 30.9555L31.0702 30.5422C30.2211 29.7191 29.3649 28.882 28.5194 28.0309L28.6715 27.9363C28.698 27.9331 28.7236 27.9246 28.7467 27.9114C28.7698 27.8981 28.7899 27.8804 28.8059 27.8592C30.8959 25.6506 32.0551 22.7352 32.0467 19.7087C32.0467 19.4671 32.0467 19.2254 32.0219 19.0082C31.8916 15.9391 30.5684 13.0386 28.3288 10.9126C26.0892 8.7866 23.1064 7.59961 20.0035 7.59961C16.9007 7.59961 13.9179 8.7866 11.6783 10.9126C9.43864 13.0386 8.11545 15.9391 7.98514 19.0082C7.98514 19.1413 7.97806 19.2744 7.96391 19.4075C7.87885 22.5317 9.04065 25.5632 11.1976 27.8452C11.2331 27.8824 11.2788 27.9085 11.3291 27.9203C11.3794 27.9322 11.432 27.9292 11.4806 27.9118L8.47691 30.8855L7.63842 31.7191L7.61012 31.7436L6.01804 33.3163C5.97684 33.3581 5.9276 33.3914 5.87322 33.4141C5.81884 33.4368 5.76041 33.4484 5.70139 33.4484C5.64238 33.4484 5.58395 33.4368 5.52957 33.4141C5.47519 33.3914 5.42595 33.3581 5.38475 33.3163C3.15912 30.9575 1.54971 28.0959 0.696679 24.9806C-0.156356 21.8652 -0.227148 18.5907 0.490468 15.442C1.20808 12.2934 2.69235 9.36622 4.81399 6.91537C6.93564 4.46453 9.63034 2.56434 12.6634 1.3803C15.6965 0.196259 18.976 -0.235731 22.2163 0.121949C25.4565 0.479629 28.5594 1.61613 31.2545 3.43249C33.9497 5.24884 36.1554 7.68996 37.6797 10.5433C39.204 13.3966 40.0005 16.5755 40 19.8033V19.8103Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1815 19.3794C32.1858 22.438 31.0116 25.383 28.8983 27.614C28.8276 27.684 28.7497 27.8487 28.6577 27.8241L27.9502 27.0851C27.9077 27.0396 27.8617 26.9975 27.8192 26.959C27.7273 26.8679 27.6317 26.7769 27.5397 26.6928C27.3664 26.5212 27.186 26.3426 27.0091 26.1814L26.7508 25.9363L26.6836 25.8697C26.634 25.8277 26.5916 25.7786 26.5421 25.7366C25.6576 24.8505 24.7731 23.9853 23.8992 23.1097L23.786 22.9976C23.7648 22.9976 23.7471 22.9556 23.7223 22.938C23.4322 22.6543 23.1456 22.3776 22.8555 22.1009V22.0554V18.798C22.8558 18.7445 22.8402 18.692 22.8106 18.6472C22.7811 18.6023 22.7389 18.5671 22.6892 18.5458L20.0712 17.39C19.9984 17.3618 19.9175 17.3618 19.8447 17.39L17.2196 18.5458C17.1711 18.5683 17.1301 18.604 17.1013 18.6486C17.0725 18.6932 17.0571 18.745 17.0568 18.798V22.0694L11.3714 27.6981H11.3501C11.2015 27.7681 11.1803 27.6981 11.1025 27.614C9.74795 26.1776 8.76862 24.4352 8.24976 22.5384C7.73089 20.6417 7.68822 18.6481 8.12544 16.7313C8.56267 14.8145 9.46655 13.0326 10.7584 11.5407C12.0502 10.0487 13.6908 8.89202 15.5374 8.17127C17.384 7.45052 19.3805 7.18756 21.3532 7.40529C23.3259 7.62302 25.2149 8.31483 26.8558 9.4205C28.4967 10.5262 29.8397 12.0122 30.7679 13.7491C31.6962 15.4861 32.1814 17.4214 32.1815 19.3864V19.3794Z",
    stroke: "#2C8C53",
    strokeWidth: 0.724207,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1367 22.8894C16.1367 22.5741 16.1367 22.2624 16.1367 21.9472C16.1367 21.6319 16.1084 21.3342 16.0766 21.0295C16.0109 20.5789 15.9683 20.1253 15.9492 19.6705C15.9547 19.2138 16.0385 18.7614 16.1969 18.3325C16.3873 17.7547 16.7121 17.2293 17.145 16.7984C17.7252 16.258 18.4495 15.8933 19.2324 15.7476C19.6173 15.6737 20.0079 15.6327 20.3999 15.625",
    stroke: "#2C8C53",
    strokeWidth: 0.666059,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7498 22.9938C14.8415 22.122 14.8141 21.2419 14.6684 20.3774C14.6684 20.3774 14.2368 16.8433 16.8655 15.2251C16.8655 15.2251 21.2773 12.458 24.1997 16.2233C24.1997 16.2233 26.2481 18.4124 25.5228 24.661",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2846 23.4177C24.2846 23.4177 25.1373 17.6069 22.0027 16.0098",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 26.255C11.3 26.255 14.0101 24.1814 13.3521 21.2182C13.105 19.9642 13.2014 18.6676 13.6313 17.4629C14.0611 16.2582 14.8089 15.1893 15.7968 14.3672",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9753 13.6283C16.9753 13.6283 21.0793 11.5268 24.4828 14.588",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2928 15.4844C25.2928 15.4844 28.0453 18.0378 26.669 25.8485",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8054 26.9376C27.8054 26.9376 28.513 24.9236 28.3998 20.5068",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1059 19.2323C28.0667 17.8602 27.6681 16.5217 26.949 15.348C26.2935 14.2707 25.3671 13.3801 24.2602 12.7631C22.9129 11.967 21.3628 11.5711 19.7947 11.6226C18.2265 11.6742 16.7063 12.1709 15.4153 13.0538C14.4797 13.6766 13.6871 14.4875 13.0891 15.4338C12.4911 16.3801 12.1011 17.4404 11.9446 18.5458",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9406 19.709C12.16 21.6739 12.2095 23.9121 10.5856 25.3446",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4892 24.8925C29.4892 24.8925 32.0329 13.6037 22.6822 10.5635",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9076 20.0835C30.9076 20.0835 31.7779 14.7841 25.9863 10.5635",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84235 24.0414C9.84235 24.0414 11.1655 23.2568 10.603 21.1307C10.603 21.1307 9.14891 9.92246 21.5423 10.3323",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52819 22.3741C9.52819 22.3741 8.42789 17.9223 10.4551 14.5879",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0497 13.4428C11.0497 13.4428 16.1373 6.11191 25.0564 10.0383",
    stroke: "#2C8C53",
    strokeWidth: 0.644914,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGate);
export default __webpack_public_path__ + "static/media/Gate.6eb0b7fb09b250f1e43f92ebe22b5e98.svg";
export { ForwardRef as ReactComponent };